<div class="card container">
  <h1 class="page-title">
    <span class="icon"><em class="fas fa-pallet"></em></span>{{ 'InboundProgress.Header' | translate }}</h1>

  <p-timeline class="hidden sm:block"[value]="events" align="top" layout="horizontal" styleClass="customized-timeline">
		<ng-template pTemplate="marker" let-event>
			<span class="custom-marker p-shadow-2" [style.backgroundColor]="event.color">
        <em [ngClass]="event.icon"></em>
      </span>
		</ng-template>
		<ng-template pTemplate="content" let-event>
			<p-card header="{{ event.status | optionsMapping:statusOptions }}" subheader="{{ event.percent }}">
        <div class="container">
          <div class="p-fluid grid">
            <div class="field col-12 mb-0">
              <label class="font-bold">{{ 'ShippingStatus.Event.Estimate' | translate }}: </label><br>
                 {{event.estimatedDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'　'}}
            </div>
            <div class="field col-12 mb-0">
              <label class="font-bold">{{ 'ShippingStatus.Event.Actual' | translate }}: </label><br>
              {{event.actualDt | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'　'}}
            </div>
            <div *ngIf="event.isShowUpdateReason" class="field col-12 mb-0">
                  <label class="font-bold">{{ 'ShippingStatus.Event.UpdateReason' | translate }}: </label><br>
                  <span class="font-bold" style="color: red;">{{event.updateReason |  replaceNullWith:'　'}}</span>
            </div>
          </div>
        </div>
			</p-card>
		</ng-template>
	</p-timeline>

  <div class="mt-2">
    <laas-data-table [expandable]="false" [tableKey]="preferenceKey" [selectable]="false" [dataKey]="'adNo'" [value]="results" [defaultColumns]="columns"
   class="hidden md:block">
      <ng-template pTemplate="caption">

      </ng-template>
     <ng-template pTemplate="header" let-columns>
       <tr>
           <th [pSortableColumn]="col.field" *ngFor="let col of columns" pResizableColumn pReorderableColumn>
               {{ col.header | translate }}
               <p-sortIcon [field]="col.field"></p-sortIcon>
           </th>
       </tr>
     </ng-template>
     <ng-template pTemplate="body" let-rowData let-columns="columns">
           <td *ngFor="let col of columns">
               <ng-container [ngSwitch]="col.field">
                   <ng-container *ngSwitchCase="'orgId'">
                    <div class="overflow-text">
                      {{ rowData[col.field] | optionsMapping:orgIdOptions }}
                    </div>
                   </ng-container>

                   <ng-container *ngSwitchCase="'lockStatus'">
                       <div class="overflow-text">
                           {{ rowData[col.field] | optionsMapping:lockStatusOptions }}
                       </div>
                   </ng-container>
                   <ng-container *ngSwitchDefault>
                     <div [ngSwitch]="col.dataType">
                         <ng-container *ngSwitchCase="'date'">
                          <div class="overflow-text">
                               {{ rowData[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                          </div>
                         </ng-container>
                         <ng-container *ngSwitchDefault>
                          <div class="overflow-text">
                             {{ rowData[col.field] | replaceNullWith:'-'}}
                          </div>
                         </ng-container>
                     </div>
                 </ng-container>
               </ng-container>
           </td>
     </ng-template>
   </laas-data-table>

   <laas-data-view class="block md:hidden " [value]="results" [paginator]="true" [totalRecords]="results" >
    <ng-template let-result pTemplate="listItem">
      <div class="field col-12">
        <div class="fluid grid laas-list-item">
          <ng-container *ngFor="let col of columns" [ngSwitch]="col.field">
            <div class="col-12 md:col-6 lg:col-4 mb-3 md:col-3 lg:col-2 mb-0 text-right">
              <label class="font-bold mb-0">{{ col.header | translate }}</label>
            </div>

            <ng-container *ngSwitchCase="'orgId'">
              <div class="field col-8 md:col-3 lg:col-2 mb-0 overflow-text">
                {{ result[col.field] | optionsMapping:orgIdOptions }}
              </div>
            </ng-container>

              <ng-container *ngSwitchCase="'lockStatus'">
                  <div class="overflow-text">
                      {{ result[col.field] | optionsMapping:lockStatusOptions }}
                  </div>
              </ng-container>

            <ng-container *ngSwitchDefault>
              <div class="field col-8 md:col-3 lg:col-2 mb-0" [ngSwitch]="col.dataType">
                <ng-container *ngSwitchCase="'date'">
                  <div class="overflow-text">
                    {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                  </div>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <div class="overflow-text">
                    {{ result[col.field] | replaceNullWith:'-'}}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </ng-container>

        </div>
      </div>

    </ng-template>
    <ng-template let-result pTemplate="gridItem">
      <div class="col-12 md:col-4 lg:col-3">
        <div class="p-fluid grid laas-grid-item">
            <ng-container *ngFor="let col of columns" [ngSwitch]="col.field">
              <div class="col-12 md:col-6 lg:col-4 mb-3 mb-0 text-right">
                <label class="font-bold mb-0">{{ col.header | translate }}</label>
              </div>

              <ng-container *ngSwitchCase="'orgId'">
                <div class="field mb-0 col-8 overflow-text">
                  {{ result[col.field] | optionsMapping:orgIdOptions }}
                </div>
              </ng-container>

                <ng-container *ngSwitchCase="'lockStatus'">
                    <div class="overflow-text">
                        {{ result[col.field] | optionsMapping:lockStatusOptions | replaceNullWith:'-' }}
                    </div>
                </ng-container>

              <ng-container *ngSwitchDefault>
                <div class="field mb-0 col-8" [ngSwitch]="col.dataType">
                  <ng-container *ngSwitchCase="'date'">
                    <div class="overflow-text">
                      {{ result[col.field] | date:'yyyy-MM-dd HH:mm:ss':this.laasSetting.facilityTimeZone | replaceNullWith:'-' }}
                    </div>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <div class="overflow-text">
                      {{ result[col.field] | replaceNullWith:'-'}}
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </ng-container>

          </div>
      </div>
    </ng-template>
    </laas-data-view>

  </div>

</div>
